import Navbar from './Navbar';
import Footer from './Footer';
import FloatingCta from './FloatingCta';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50 text-slate-900 font-sans">
      <Navbar />
      <main className="flex-grow pt-[104px] sm:pt-[112px] pb-16 sm:pb-0">
        {children}
      </main>
      <FloatingCta />
      <Footer />
    </div>
  );
}
